import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api, {
	RedemptionCodeListSortField,
	SortOrder,
	ExportType,
} from '../../api';

interface RedemptionCodeSliceState {}

const initialState: RedemptionCodeSliceState = {};

interface GetSubmissionsListQuery {
	redeemed?: boolean;
	projectId: number;
	pageNumber: number;
	pageSize: number;
	sortField: RedemptionCodeListSortField;
	sortOrder: SortOrder;
}

export const getRedemptionCodes = createAsyncThunk(
	'redemptionCode/getRedemptionCodes',
	async ({
		projectId,
		pageNumber,
		pageSize,
		sortField,
		sortOrder,
	}: GetSubmissionsListQuery) => {
		return await api.getProjectRedemptionCodes(
			projectId,
			sortField,
			sortOrder,
			pageNumber,
			pageSize,
		);
	},
);

export const deleteRedemptionCodes = createAsyncThunk(
	'redemptionCode/deleteRedemptionCodes',
	async (params: { projectId: number; ids: number[] }) => {
		return await api.deleteRedemptionCodes(params.projectId, params.ids);
	},
);

export const generateRedemptionCodes = createAsyncThunk(
	'redemptionCode/generateRedemptionCodes',
	async (
		params: { projectId: number; number: number },
		{ rejectWithValue },
	) => {
		try {
			return await api.generateRedemptionCodes(params.projectId, {
				number: params.number,
			});
		} catch (error) {
			return rejectWithValue(error);
		}
	},
);

export const exportRedemptionCodes = createAsyncThunk(
	'redemptionCode/exportRedemptionCodes',
	async (params: {
		projectId: number;
		sortField: RedemptionCodeListSortField;
		sortOrder: SortOrder;
		redeemed?: boolean;
	}) => {
		const { projectId, sortField, sortOrder, redeemed } = params;
		const result = await api.exportRedemptionCodes(
			projectId,
			sortField,
			sortOrder,
			ExportType.Csv,
		);

		return {
			url: URL.createObjectURL(result.data),
			fileName: result.fileName,
		};
	},
);

const redemptionCodeSlice = createSlice({
	name: 'redemptionCode',
	initialState,
	reducers: {},
	extraReducers: () => {},
});

const { reducer } = redemptionCodeSlice;

export default reducer;
